<template>
  <div>
    <!-- <the-live-chat></the-live-chat> -->
  </div>
</template>

<script>
// import TheLiveChat from './components/TheLiveChat.vue';

export default {
  name: 'App',
  components: {
    // TheLiveChat,
  }
}
</script>
